import React, { useEffect, useState, useRef } from "react"
import { Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next"
import { withRouter, Link , useHistory} from "react-router-dom"
import { size } from "lodash"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import SimpleBar from "simplebar-react"
import {
  Card,
  CardBody,
  CardTitle,
  Media,
  CardText,
  CardHeader,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
  Button,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from "reactstrap"
import * as moment from "moment"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getPurchaseEntryList } from "helpers/backend_helper"
import { getSupplierPurchaseSummary } from "helpers/backend_helper"
import { getAllSuppliers as onGetAllSuppliers } from "store/products/actions"

const SupplierListAndDetails = (props) => {

  const dispatch = useDispatch()
  const history = useHistory()

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setSelectedSupplierId(params.id)
      getAllDetails(params.id)
    } 
  }, [])

  function getAllDetails(supplierid){
    const selSupp = supplierList.filter(each=>each.value == supplierid)
    getSupplierSummary({
      supplierid: supplierid
    },selSupp[0])
    getSupplierPurchaseList({
      supplierid: supplierid
    })
    if(selSupp && selSupp.length > 0){
      setSelectedSupplier(selSupp[0])
    }
  }

  useEffect(() => {
    dispatch(onGetAllSuppliers(true))
  }, [dispatch]);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  const [purchaseEntryList, setPurchaseEntryList] = useState([])
  const [showLoading, setShowLoading] = useState(false)
  const [searchInProgress, setSearchInProgress] = useState(false)
  const [selectedSupplierId, setSelectedSupplierId] = useState()
  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [supplierFilteredList, setSupplierFilteredList] = useState([])
  const [supplierPurchaseSummary, setSupplierPurchaseSummary] = useState({})

  const { supplierList } = useSelector(state => ({
    supplierList: state.Products.suppliers,
  }))

  useEffect(() => {
    setSupplierFilteredList(supplierList)
    scrollToBottom()
  }, [supplierList])

  async function getSupplierSummary(searchCriteria, currentSupp){
    setShowLoading(true)
    getSupplierPurchaseSummary(searchCriteria).then(result => {
      if(currentSupp && currentSupp.openingBalance && Number(currentSupp.openingBalance) > 0){
        setSupplierPurchaseSummary({
          ...result,
          totalamount:Number(result.totalamount) + Number(currentSupp.openingBalance),
          balanceamount: Number(result.balanceamount) + Number(currentSupp.openingBalance),
        })
      }
      else{
        setSupplierPurchaseSummary(result)
      }
      setShowLoading(false)
    })
  }

  async function getSupplierPurchaseList(searchCritiria){
    setSearchInProgress(true)
    getPurchaseEntryList(searchCritiria).then(result => {
      setPurchaseEntryList(result)
      setSearchInProgress(false)
    })
  }

  function close(){
    history.push('/list-supplier')
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const pageOptions = {
    sizePerPage: 15,
    totalSize: size(purchaseEntryList), 
    custom: true,
  }

  const PurchaseEntryListColumns = () => [
    {
      dataField: "suppinvoiceno",
      text: "Inv #",
      sort: true
    },
    {
      dataField: "invoicedate",
      text: "Invoice Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "grandtotal",
      text: "Amount",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
        </div>
      ),
    },
    {
      dataField: "cashpaid",
      text: "Balance",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {(Number(row.grandtotal) - Number(cellContent)).toLocaleString('en-IN',{minimumFractionDigits: 2})}
        </div>
      ),
    },
    ,
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => (
        <Badge className={cellContent== "PAID"? "font-size-12 bg-success badge-success":"font-size-12 bg-warning badge-warning"}>
          {cellContent}
        </Badge>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18 pointer-cursor" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              tag={Link} 
              to={"/edit-purchaseentry/"+item.id}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              Edit
            </DropdownItem>
            <DropdownItem
              tag={Link} 
              to={"/add-purchase-payment/"+item.supplierid}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-dollar font-size-16 text-primary me-1" />{" "}
              Add Payment
            </DropdownItem>
            <DropdownItem
              href="#"
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-reset font-size-16 text-danger me-1" />{" "}
              Add Purchase Return
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Manage" breadcrumbItem="Supplier Transactions" breadcrumbLink="/list-supplier"/>
          <Card>
            <CardBody className="no-x-padding">
              <Row className="">
                <Col lg="4">
                  <Row>
                    <Col className="text-center fw-medium font-size-15">
                      Suppliers
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3 ms-2 pt-2">
                    <Select
                      onChange={(e) => {
                        setSelectedSupplier(e)
                        if(e?.value){
                          setSelectedSupplierId(e.value)
                          getAllDetails(e.value)
                          const fileredList = supplierList.filter(each => each.value == e.value)
                          setSupplierFilteredList(fileredList)
                        }
                        else{
                          setSupplierFilteredList(supplierList)
                        }
                      }}
                      isClearable
                      value={selectedSupplier}
                      options={supplierList}
                      classNamePrefix="select2-selection"
                      isLoading={false}
                      id="productcustomer"
                    />
                  </div>

                  <SimpleBar style={{ maxHeight: "650px" , paddingBottom:"30px"}} autoHide={false}>
                  {supplierFilteredList.map((entry, i) => (
                    <React.Fragment key={"outer"+i}>
                      {selectedSupplierId == entry.value ? <div ref={messagesEndRef} key={"sel-"+i} />: null}
                      <div className={selectedSupplierId == entry.value ? "border-bottom pointer-cursor-with-hover px-2 bg-light-blue" : "border-bottom pointer-cursor-with-hover px-2 "} key={i} onClick={()=>{
                        //getSalesEntryDetails(entry)
                        setSelectedSupplierId(entry.value)
                        getAllDetails(entry.value)
                      }}>
                        <CardBody className="no-gutters">
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm border-end pe-1">
                              <span className="avatar-title rounded-circle bg-light text-primary font-size-20">
                                <i className="fas fa-shipping-fast font-size-20"></i>
                              </span>
                            </div>
                            <div className="ps-2">
                              <h5>{entry.name ? entry.name : "-"}</h5>
                              {entry.address && <p className="text-muted mb-1"><i className="bx bx-id-card"/> {entry.address}</p>}
                              {entry.email && <p className="text-muted mb-1"><i className="bx bx-envelope"/> {entry.email}</p>}
                              {entry.mobile && <p className="text-muted mb-0"> <i className="bx bx-mobile"/> {entry.mobile}</p>}
                            </div>
                          </div>
                        </CardBody>
                      </div>
                    </React.Fragment>
                  ))}
                    
                  </SimpleBar>
                  {(!searchInProgress && supplierFilteredList.length == 0) && 
                    <Card color="warning" >
                      <CardBody>
                        <CardText className="font-size-16">
                          <i className="bx bx-sad me-1" /> Sorry, nothing found !!!
                        </CardText>
                      </CardBody>
                    </Card>
                  }
                </Col>
                <Col lg="8">
                {showLoading ? 
                <div className=" text-center">
                  <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                </div>
                : 
                <>
                  <Row className="mt-1">
                    <Col className="text-end">
                      <Button className="btn btn-sm ms-1 me-2" onClick={() => {
                          close()
                        }}
                        >
                        <i className="fas fa-window-close"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1 py-2">
                    <Col className="d-lg-flex justify-content-between">
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                OB
                              </p>
                              <h4 className="mb-0">{selectedSupplier && selectedSupplier.openingBalance ? Number(selectedSupplier.openingBalance).toLocaleString('en-IN',{minimumFractionDigits: 2}): ""}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="bx bx-copy-alt font-size-20"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Txns #
                              </p>
                              <h4 className="mb-0">{supplierPurchaseSummary.txncount}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="bx bx-copy-alt font-size-20"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Total
                              </p>
                              <h4 className="mb-0">{Number(supplierPurchaseSummary.totalamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-info">
                                <i className="bx bx-purchase-tag-alt font-size-20"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Paid
                              </p>
                              <h4 className="mb-0">{Number(supplierPurchaseSummary.paidamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-success">
                                <i className="bx bx-archive-in font-size-20"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Balance
                              </p>
                              <h4 className="mb-0">{Number(supplierPurchaseSummary.balanceamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-warning">
                                <i className="bx bx-bullseye font-size-20"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="invoiceno"
                      columns={PurchaseEntryListColumns()}
                      data={purchaseEntryList}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="invoiceno"
                          data={purchaseEntryList}
                          columns={PurchaseEntryListColumns()}
                          bootstrap4
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive min-height-200">
                                    <BootstrapTable
                                      keyField="invoiceno"
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      //defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-hover"
                                      }
                                      headerWrapperClasses={"table-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                      noDataIndication={<div className="text-center">- No transactions found -</div>}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </Row>
                </>
                }
                </Col>
              </Row>
              
            </CardBody>

          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SupplierListAndDetails
